import React from "react";
import { FigureHorStackBarKpiProviders } from "../categoryChartQueryFns";
import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { FigureWithHorStackBar } from "./FigureWithHorStackBar";
import { PROVIDER_TITLE_CLASS } from "../misc";
import { CategoryChart } from "../processors";
import styles from "./CategoryChart.module.scss";

interface FigureWithHorStackBarProvidersProps extends FigureHorStackBarKpiProviders {
    categoryChart: CategoryChart;
}

export const FigureWithHorStackBarProviders: React.FC<FigureWithHorStackBarProvidersProps> = ({
    categoryChart,
    title,
    footer,
    elements,
    waterProviders,
    unit,
    year
}) => {
    const { category } = useCategoryContext();
    if (!category) return null;

    return (
        <div className="row">
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            {elements?.map((element, index) => {
                return (
                    element != null &&
                    waterProviders?.[index] != null && (
                        <div className="col-12" key={index}>
                            <div className="headline">
                                <div className={`${styles.providerTitle} ${PROVIDER_TITLE_CLASS} ${styles.left}`}>
                                    {waterProviders[index].name}
                                </div>
                            </div>
                            <FigureWithHorStackBar
                                categoryChart={categoryChart}
                                figure={element.figure}
                                graph={element.graph}
                                unit={unit}
                                colorIndex={index}
                                waterProvider={waterProviders[index]}
                                year={year}
                            />
                        </div>
                    )
                );
            })}
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
        </div>
    );
};
